import InputPassword from './input-password';

export default InputPassword;
export type * from './types';
